import { render, staticRenderFns } from "./IdentifierPage.vue?vue&type=template&id=25fee12c&scoped=true"
import script from "./IdentifierPage.vue?vue&type=script&lang=js"
export * from "./IdentifierPage.vue?vue&type=script&lang=js"
import style0 from "./IdentifierPage.vue?vue&type=style&index=0&id=25fee12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fee12c",
  null
  
)

export default component.exports